<template>
  <div 
    id="ReverseLogisticsMenu" 
    class="left-menu"
  >
    <div class="nav-sub">
      <h4>Claims &amp; Returns</h4>
      <ul>
        <li v-if="IsClaimsSectionEnabled">
          <router-link to="/ClaimsAndReturns/Claims">
            View Claims
          </router-link>
        </li>
        <li v-if="IsReturnsSectionEnabled">
          <router-link to="/claimsAndReturns/returns">
            View Returns
          </router-link>
        </li>
        <li v-if="IsEntitlementsSectionEnabled">
          <router-link :to="{name: 'Entitlements'}">
            Entitlements
          </router-link>
        </li>
        <li v-if="IsEntitlementsSectionEnabled">
          <router-link :to="{name: 'OpenCoreCreditRequests'}">
            View Open CCRs
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { siteSectionsHelper } from "@/components/mixins/siteSectionsHelper";

  export default {
    mixins: [siteSectionsHelper]
  };
</script>
